/** @jsx h */
import { h } from 'preact';
import { UIPlugin } from '@uppy/core';

import './style.scss';

export default class LoadingStatus extends UIPlugin {
  constructor(uppy, opts) {
    super(uppy, opts);
    this.id = this.opts.id || 'LoadingStatus';
    this.type = 'progressindicator';

    this.render = this.render.bind(this);
    this.install = this.install.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  show() {
    this.parent?.disableAllFocusableElements?.(true);
    this.setPluginState({ isLoading: true });
  }

  hide() {
    this.parent?.disableAllFocusableElements?.(false);
    this.setPluginState({ isLoading: false });
  }

  render() {
    const { isLoading } = this.getPluginState();
    const activeClassName = isLoading ? 'kj-uploader-LoadingStatus--is-loading' : '';

    return (
      <div className={`kj-uploader-LoadingStatus ${activeClassName}`}>
        <svg className="kj-uploader-LoadingStatus__spinner" viewBox="25 25 50 50">
          <circle
            className="kj-uploader-LoadingStatus__spinner-path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke="0072EF"
            strokeWidth="2"
          />
        </svg>
      </div>
    );
  }

  install() {
    this.setPluginState({
      isLoading: false,
    });

    const { target } = this.opts;
    if (target) {
      this.mount(target, this);
    }
  }

  uninstall() {
    this.unmount();
  }
}
